import { ERA_LOOKS } from '@continuum/show-core';
import type { TaskDef } from '@continuum/show-core';
import { Screen } from '../../ui/Shell.js';
import { Eyebrow, Lede, Spacer } from '../../ui/atoms.js';
import { TaskQueue } from '../../ui/TaskQueue.js';
import type { QueueRow } from '../../ui/TaskQueue.js';
import type { ScreenCopy } from '../../ui/screenText.js';

/**
 * Era 1 — Earth, now. Ordinary games like every other stop: a line about where we are, the planet with
 * the ship's orbit round it, and the list. (Until 2026-10-24 it had a TAP button and a POWER count of its
 * own that charged nothing; the games are the charge.)
 */
export function Earth({
  rows,
  s,
  title,
  onOpen,
}: {
  rows: QueueRow[];
  s: ScreenCopy;
  title: (def: TaskDef) => string;
  onOpen: (row: QueueRow) => void;
}) {
  const look = ERA_LOOKS[1];
  return (
    <Screen style={{ background: 'linear-gradient(180deg,#060b18,#0a1122)', color: '#e6efff', padding: 24 }}>
      <Eyebrow color={look.acc}>{s.era1Eyebrow}</Eyebrow>
      <h1 style={{ margin: '12px 0 6px', fontSize: 24, fontWeight: 700, letterSpacing: 2 }}>{s.era1Title}</h1>
      <Lede color="#8fa6c4">{s.era1Lede}</Lede>

      {/* The planet, and the ship going round it before it leaves. */}
      <div aria-hidden="true" style={{ margin: '22px auto 6px', position: 'relative', width: 160, height: 160, flex: 'none' }}>
        <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', border: '1px solid rgba(111,183,255,.3)' }} />
        <div style={{ position: 'absolute', inset: 8, animation: 'ccSwirl 9s linear infinite' }}>
          <div
            style={{
              position: 'absolute',
              top: -3,
              left: '50%',
              marginLeft: -3,
              width: 7,
              height: 7,
              borderRadius: '50%',
              background: look.acc,
              boxShadow: `0 0 10px ${look.acc}`,
            }}
          />
        </div>
        <div style={{ position: 'absolute', inset: 34, borderRadius: '50%', background: 'radial-gradient(circle at 40% 32%,#2c5aa8,#122850)' }} />
      </div>

      <TaskQueue rows={rows} look={look} s={s} title={title} onOpen={onOpen} />
      <Spacer min={12} />
    </Screen>
  );
}
